import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const Header = () => {
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation(); // Hook to get the current URL location

  // Check if the user is logged in when the component mounts
  useEffect(() => {
    const storedUserId = sessionStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId); // Set the userId if it exists in sessionStorage
    }
  }, []);


  const handleLogout = () => {
    sessionStorage.removeItem('userId'); // Remove the userId from sessionStorage
    sessionStorage.removeItem('token'); // Remove the access token from sessionStorage
    setUserId(null); // Clear the userId in the state
    navigate('/'); // Redirect to the HomePage after logging out
  };

  const toDashboard = async () => {
    navigate('/admin/dashboard', { state: { view: 'TemplateManagement' } });
  };

  // Check if the current path includes 'survey'
  const isSurveyPage = location.pathname.includes('/survey');

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 40px',
          position: 'relative',
          zIndex: 10,
          backgroundColor: 'transparent', // Maintain the original background color
        }}
      >
        {/* Logo - Link to HomePage */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img
              src="/racine.png"
              alt="International Student Review"
              style={{ width: '120px', height: 'auto', marginLeft: '30px', cursor: 'pointer' }}
            />
          </Link>
        </Box>

        {/* Navigation */}
        <Box sx={{ display: 'flex', gap: '30px', marginRight: '30px' }}>
          {!isSurveyPage && !userId && ( // Hide these links if user is on the survey page or logged in
            <>
              <Typography
                component={Link}
                to="/solutions"
                variant="h6"
                sx={{ color: '#000', cursor: 'pointer', textDecoration: 'none' }}
              >
                Solutions
              </Typography>
              <Typography
                component={Link}
                to="/resources"
                variant="h6"
                sx={{ color: '#000', cursor: 'pointer', textDecoration: 'none' }}
              >
                Resources
              </Typography>
              <Typography
                component={Link}
                to="/contact"
                variant="h6"
                sx={{ color: '#000', cursor: 'pointer', textDecoration: 'none' }}
              >
                Contact Us
              </Typography>
            </>
          )}

          {userId ? (
            <>
              <Typography
                component={Link}
                to="/admin/dashboard"
                state={{ view: 'DashboardView' }}
                variant="h6"
                sx={{ color: '#000', cursor: 'pointer', textDecoration: 'none' }}
              >
                Dashboard
              </Typography> 
              <Typography
                component={Link}
                to="/admin/guide"
                state={{ view: 'DashboardView' }}
                variant="h6"
                sx={{ color: '#000', cursor: 'pointer', textDecoration: 'none' }}
              >
                UserGuide
              </Typography> 
            </>
          ) : (
            !isSurveyPage && ( // Hide login button if user is on the survey page
              <Button
                component={Link}
                to="/login"
                sx={{
                  color: '#E85648',
                  borderColor: '#bc2534',
                  marginRight: '15px',
                }}
                variant="outlined"
              >
                LOG IN
              </Button>
            )
          )}

          {userId && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <Typography variant="h6" sx={{ color: '#000' }}>
                User: {userId}
              </Typography>
              <Button
                sx={{ color: '#bc2534', borderColor: '#bc2534', marginRight: '15px' }}
                variant="outlined"
                onClick={handleLogout}
              >
                Log Out
              </Button>
              <Button
                component={Link}
                to="/register"
                sx={{ backgroundColor: '#bc2534', color: 'white' }}
                variant="contained"
              >
                ADD USER
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      {/* Separator */}
      <Box
        sx={{
          height: '0',
          width: '100%',
          borderTop: '2px dashed #1E2742', // Dashed line
          margin: '0',
        }}
      />
    </>
  );
};

export default Header;
